import { PERMISSIONS } from '../../constants'
import list from './RatingPollItemList'
import create from './RatingPollItemCreate'
import edit from './RatingPollItemEdit'

export default {
  edit,
  create,
  list,
  name: 'rating-poll-items',
  permissions: [PERMISSIONS.RATING_POLL_ITEMS],
  options: { label: 'Enquetes de avaliação' },
}
